import { render } from "./Logo-NONBETA.vue?vue&type=template&id=74ee1ff6"
import script from "./Logo-NONBETA.vue?vue&type=script&lang=js"
export * from "./Logo-NONBETA.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__